import "./styles.css";

export default function Footer() {

  return (
    <div className="footer">
        <span>Todos os direitos reservados - 2025</span>
    </div>
  );
}
